module.exports = __webpack_public_path__ + "24e65424c5b0655661ee0651c7f71128.svg";